/**
 * Hauteur du bandeau « en tant que », publiée par lui sur `:root` (0 hors session). Un écran en pleine hauteur la
 * retire de la sienne : sinon il déborde et pousse le bandeau hors de l'écran (recette du 29/10/2026).
 */
export const IMPERSONATION_BANNER_HEIGHT_PROPERTY =
  '--impersonation-banner-height'

export const IMPERSONATION_BANNER_HEIGHT = `var(${IMPERSONATION_BANNER_HEIGHT_PROPERTY}, 0px)`
